/**
 * File to hold all our VueJS plugins
 */

/**
 * flash helper
 * @param  {string} message
 * @param  {String} level
 */
window.events = new Vue();

window.flash = function (message, level = 'success') {
    window.events.$emit('flash', message, level);
};

/**
 * Vue loading overlay
 */
import Loading from 'vue-loading-overlay';
Vue.use(Loading);

/**
 * Vue DatePicker
 */
import datePicker from 'vue-bootstrap-datetimepicker';
Vue.use(datePicker);

/**
 * vue moment gives {{ | moment }} filters
 */
import VueMoment from 'vue-moment';
Vue.use(VueMoment, {
    moment,
});

/**
 * unique id helper, gives this.uid, this.$id(), this.$idRef()
 */
import UniqueId from 'vue-unique-id';

Vue.use(UniqueId);

/**
 * Ziggy
 */
import { ZiggyVue } from 'ziggy-js';
Vue.use(ZiggyVue, window.Ziggy);

/*
 * Vue MQ (MediaQuery)
 */
import VueMq from 'vue-mq'
Vue.use(VueMq, {
    breakpoints: {
        xs: 576,
        sm: 768,
        md: 992,
        lg: 1200,
        xl: 1440,
        '2xl': 1908,
        '3xl': 2496,
        '4xl': Infinity
    }
});

//github.com/Inndy/vue-clipboard2
import VueClipboard from 'vue-clipboard2';
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

/*
 * Vue Nl2Br
 */
import Nl2br from 'vue-nl2br'
Vue.component('nl2br', Nl2br)

/*
 * Vue vue-plugin-load-script
 */
import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);

/*
 * lwk Deployment helper
 */
import Deployment from './plugins/deployment.js'
Vue.use(Deployment);

/*
 * lwk Currency helper
 */
import Currency from './plugins/currency.js'
Vue.use(Currency);

/*
 * Laravel permission to Vuejs
 * https://github.com/ahmedsaoud31/laravel-permission-to-vuejs/tree/master
 */
import LaravelPermissionToVueJS from 'laravel-permission-to-vuejs'
Vue.use(LaravelPermissionToVueJS)

/*
 * JsonEditorVue
 * https://github.com/cloydlau/json-editor-vue
 */
import JsonEditorVue from 'json-editor-vue'

Vue.use(JsonEditorVue, {
  // global props & attrs (one-way data flow)
})

/*
 * Vue Trix
 */
import VueTrix from "vue-trix";
Vue.use(VueTrix);
